// extracted by mini-css-extract-plugin
export default {"textbook":"Textbook_textbook__YRU+m","content":"Textbook_content__+QbAk","title":"Textbook_title__mFO90","promo":"Textbook_promo__9fbsf"};